const getInitials = (first_name, last_name) => {
  const cleanFirst =
    first_name && first_name.trim()
      ? first_name.trim().toUpperCase()
      : '';
  const cleanLast =
    last_name && last_name.trim()
      ? last_name.trim().toUpperCase()
      : '';

  let initials =
    (cleanFirst.charAt(0) || '') +
    (cleanLast.charAt(0) || '');

  // Ensure at least 2 characters
  if (initials.length < 2) {
    const extraChars =
      cleanFirst.slice(1, 2) || cleanLast.slice(1, 2) || '';
    initials += extraChars;
  }

  return initials;
};

export default getInitials;
